/* eslint-disable @typescript-eslint/no-unused-vars */
import MainMenu from "./lib/MainMenu";
import useBreakpoints from "hooks/useBreakpoints";
import { useEffect, useRef, useState } from "react";
import {
	Slide,
	Container,
	useScrollTrigger,
	useMediaQuery
} from "@mui/material";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { useNavigationMenu } from "hooks/useNavigationMenu";
import { ISectionMenuItem } from "./types";
import { useAppSelector } from "hooks";
import { selectPoisBountyV3State } from "redux/slices";
import {
	MainMenuContainer,
	mainMenuContainerInnerSxProps,
	Nav,
	SectionMenuContainer,
	sectionMenuContainerSxProps,
	sectionMenuInnerSxProps
} from "./styled";
import { SectionMenu } from "./lib/SectionMenu";

const PageTopNavV2 = ({
	sectionMenuData: sectionItems,
	isAppBarFixed = true,
	isLandingPage = false,
	navItemColor,
	hasSectionBanner = false,
	showSubmenu = true,
	transparentMainBackground = false
}: {
	sectionMenuData: ISectionMenuItem[];
	className?: string;
	isAppBarFixed?: boolean;
	isLandingPage?: boolean;
	navItemColor?: string;
	hasSectionBanner?: boolean;
	showSubmenu?: boolean;
	transparentMainBackground?: boolean;
}): JSX.Element => {
	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const trigger = useScrollTrigger({ threshold: 35 });
	const sliderRef = useRef<HTMLElement | null>(null);
	const { isSmDown, isLgDown } = useBreakpoints();
	const isHideOnScrollEnabled = false;

	const isPortrait = useMediaQuery("(max-width: 719px)");
	const isLowWidth = useMediaQuery("(max-width: 944px)");

	const sectionMenuTop = (() => {
		const top = isAppBarFixed
			? isHideOnScrollEnabled && trigger
				? "0"
				: isSmDown
				? "55px"
				: isLgDown
				? "63px"
				: "65px"
			: "40%";

		return { xs: top || "82px", sm: top || "65px", lg: "63px" };
	})();

	const sectionMenuMarginTop = hasSectionBanner
		? isPortrait
			? "42%"
			: isLowWidth
			? "22%"
			: "20%"
		: "0px";

	// this disables the transition effect when switching between "pages"
	useEffect(() => {
		setTimeout(() => {
			setIsLoaded(true);
		}, 0);
	}, []);

	const { userTracker, nowTime } = useWebStoreContext();
	const { eventActive: isPoisActive } = useAppSelector(selectPoisBountyV3State);

	const navigation = useNavigationMenu(
		userTracker?.clubId,
		isPoisActive,
		userTracker,
		nowTime
	).filter(
		(navItem) =>
			!navItem?.isExternal &&
			navItem?.isEnabled &&
			navItem?.isDisplayInPageTopNav
	);

	return (
		<>
			<Slide
				ref={sliderRef}
				appear={false}
				direction="down"
				in={true}
				style={{
					zIndex: 100
				}}
				timeout={{ enter: 300, exit: 300 }}
			>
				<MainMenuContainer
					nav-item-color={navItemColor}
					className="main-menu-container"
					sx={{
						background:
							isLandingPage || transparentMainBackground ? "none" : "",
						a: {
							color: isLandingPage ? "white" : "",
							textShadow: isLandingPage ? "1px 1px 1px #444" : ""
						}
					}}
				>
					<Container
						className="main-menu-container-inner"
						sx={{
							...mainMenuContainerInnerSxProps,
							padding: { xs: "0px", lg: "0px" }
						}}
					>
						<Nav>
							<MainMenu pages={navigation} />
						</Nav>
					</Container>
				</MainMenuContainer>
			</Slide>
			{showSubmenu && (
				<SectionMenuContainer
					id="sub-menu"
					className="section-menu-container"
					sx={{
						...sectionMenuContainerSxProps,
						width: "100%",
						marginTop: sectionMenuMarginTop,
						top: sectionMenuTop,
						transition: isLoaded ? "top 0.18s linear" : "none",
						position: "sticky"
					}}
				>
					<Container
						className="section-menu-inner"
						sx={{ ...sectionMenuInnerSxProps }}
					>
						<SectionMenu items={sectionItems} />
					</Container>
				</SectionMenuContainer>
			)}
		</>
	);
};

export default PageTopNavV2;
export * from "./types";
